module.exports = __webpack_public_path__ + "static/media/html.c83aaf39.svg";